<template>
  <v-app>
    <d-header
      v-model="drawer"
      title="Portal Transparencia"
      :username="fullname"
      :logged="logged"
      :profile="profile"
      show-side-icon
    />
    <v-navigation-drawer v-model="drawer" fixed clipped app width="300">
      <v-list dense>
        <template v-for="(item, i) in items">
          <v-list-group v-if="item.children" :key="i" :value="item.active" no-action>
            <v-list-item slot="activator" class="px-0">
              <v-list-item-action class="mr-2">
                <v-icon>{{ item.icon }}</v-icon>
              </v-list-item-action>
              <v-list-item-content>
                <v-list-item-title>
                  {{ item.text }}
                </v-list-item-title>
              </v-list-item-content>
            </v-list-item>
            <v-list-item v-for="(child, j) in item.children" :key="i + '-' + j" :to="child.href" exact>
              <v-list-item-action v-if="child.icon" class="mr-2">
                <v-icon>{{ child.icon }}</v-icon>
              </v-list-item-action>
              <v-badge v-if="child.count > 0" color="red">
                <span slot="badge">{{ child.count }}</span>
                <v-list-item-content>
                  <v-list-item-title>
                    {{ child.text }}
                  </v-list-item-title>
                </v-list-item-content>
              </v-badge>
              <v-list-item-content v-else>
                <v-list-item-title>
                  {{ child.text }}
                </v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </v-list-group>
          <v-list-item v-else :key="i" :to="item.href" exact>
            <v-list-item-action class="mr-2">
              <v-icon>{{ item.icon }}</v-icon>
            </v-list-item-action>
            <v-list-item-content>
              <v-list-item-title>
                {{ item.text }}
              </v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </template>
      </v-list>
      <template #append>
        <div class="text-center mb-5" style="font-size: 12px;">
          v{{ appVersion }}
        </div>
      </template>
    </v-navigation-drawer>
    <v-main>
      <v-container id="contenedor" fluid>
        <router-view />
      </v-container>
      <d-refresher />
      <d-notifier />
    </v-main>
    <d-profile />
    <d-footer />
  </v-app>
</template>

<script>
const DRefresher = () => import('@demre/client-common/src/components/jwt-refresher');
const DHeader = () => import('@demre/client-common/src/components/header');
const DNotifier = () => import('@demre/client-common/src/components/notifier');
const DProfile = () => import('@demre/client-common/src/components/profile');
const DFooter = () => import('./common/FooterPublic');

export default {
  components: {
    DRefresher,
    DHeader,
    DFooter,
    DNotifier,
    DProfile,
  },
  data:() => ({
    drawer: true,
  }),
  computed: {
    appVersion() {
      return process.env.VUE_APP_VERSION;
    },
    items() {
      const subMenuMantenedor = [
        { icon: '$clipboard_list_outline', text: 'Procesos', href: { name: 'procesos' }, active: false },
        { icon: '$clipboard_list_outline', text: 'Bases', href: { name: 'bases' }, active: false },
      ];
      return [
        { icon: 'list', text: 'Portal de Datos' , active: false,
          children: [
          ...(this.accesoMantenedor ? subMenuMantenedor : [])
          ]
        },
      ]
    },
    fullname() {
      const me = this.$store.state.me;
      const notEmpty = !!Object.keys(me).length;
      return notEmpty ? `${me.nombres} ${me.paterno} ${me.materno}` : '';
    },
    logged() {
      return this.$store.getters['session/isLoggedIn']();
    },
    profile() {
      return [
        { title: 'Cambiar contraseña y/o Email', icon: 'account_circle', action: () => this.$store.commit('setProfile', true) },
        { title: 'Salir', icon: 'power_settings_new', action: () => this.$store.dispatch('session/logout') }
      ];
    },
    rol(){
      return this.$store.state.usuario.rol[0];
    },
    accesoMantenedor() {
      return ['personal-demre'].includes(this.rol?.nombre);
    },
  },
};
</script>
